import React, { useState, useEffect, Fragment } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink,
  Redirect,
  useHistory,
  useLocation,
  Link,
} from "react-router-dom";
// import {HashRouter as Router, Switch, Route,	NavLink, Redirect} from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";

// Material-UI Core
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import Divider from "@material-ui/core/Divider";

// Material Icon
import WidgetsIcon from "@material-ui/icons/Widgets";
import DashboardIcon from "@material-ui/icons/Dashboard";
import FolderIcon from "@material-ui/icons/Folder";
import BurstModeIcon from "@material-ui/icons/BurstMode";
import MailIcon from "@material-ui/icons/Mail";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import DescriptionIcon from "@material-ui/icons/Description";
import ViewListIcon from "@material-ui/icons/ViewList";
import GroupIcon from "@material-ui/icons/Group";
import PersonIcon from "@material-ui/icons/Person";
import LayersIcon from "@material-ui/icons/Layers";
import CompareArrowsIcon from "@material-ui/icons/CompareArrows";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ListAltIcon from "@material-ui/icons/ListAlt";
import EventNoteIcon from "@material-ui/icons/EventNote";

// Custom Component
// import {SiteButton, SiteIcon} from './SiteMenu'
// import {LanguageButton, LanguageIcon} from './LanguageMenu'
import SiteButton from "./SiteMenu";
import LanguageButton from "./LanguageMenu";
import UserMenu from "./UserMenu";
import NavBarStyle from "../../styles/jss/components/navBarStyle";
import isLoggedIn from "../isLoggedIn";

// Router
import Dashboard from "../../views/Dashboard/Dashboard";
// import RFI from '../../views/RFI/RFI'
import Efiling from "../../views/Efiling/Efiling";
import DrawingRegister from "../../views/DrawingRegister/DrawingRegister";
import DrawingRegisterO from "../../views/DrawingRegister/DrawingRegisterO";
import DocumentSubmission from "../../views/DocumentSubmission/DocumentSubmission";
import RFI from "../../views/DocumentWorkflow/RFI";
import Transmittal from "../../views/DocumentWorkflow/Transmittal";
import Circulation from "../../views/Circulation/Circulation";
import PAS from "../../views/Form/PAS";
import ProjectInformation from "../../views/Form/ProjectInformation";
import DPS from "../../views/Form/DPS";
import PMS from "../../views/Form/PMS";
import AIS from "../../views/Form/AIS";
import UserGroup from "../../views/UserGroup/UserGroup";
import Wirs from "../../views/Wirs/Wirs";
// import SfpSingIn from '../SignIn/SfpSignIn'

// Fetch Data
import { getModule, getSite } from "../../dataSource/userModule";

const useStyles = makeStyles((theme) => NavBarStyle(theme));

const MenuAppBar = () => {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const store = require("store");

  // const {history} = props
  const [siteList, setSiteList] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [subMenuOpen, setSubMenuOpen] = useState({});

  // Redux Data
  const userSitesRedux = useSelector((state) => state.userSitesRedux);
  const userModulesRedux = useSelector((state) => state.userModulesRedux);

  const handleDrawer = () => {
    setMenuOpen(!menuOpen);
    handleSubMenuClose();
  };

  const handleDrawerOpen = () => {
    setMenuOpen(true);
  };

  const handleDrawerClose = () => {
    setMenuOpen(false);
    handleSubMenuClose();
  };

  const handleSubMenu = (name) => {
    setSubMenuOpen({ ...subMenuOpen, [name]: !subMenuOpen[name] });
  };

  const handleSubMenuOpen = () => {
    setSubMenuOpen(true);
  };

  const handleSubMenuClose = () => {
    setSubMenuOpen(false);
  };

  const createModuleIcon = (moduleName) => {
    let iconName = "";

    switch (moduleName) {
      case "/dashboard":
        iconName = <DashboardIcon className={classes.menuIconProperties} />;
        break;
      case "#form":
        iconName = <ListAltIcon className={classes.menuIconProperties} />;
        break;
      // case "/pas":
      //   iconName = <EventNoteIcon className={classes.menuIconProperties} />;
      //   break;
      case "/pil":
        iconName = <EventNoteIcon className={classes.menuIconProperties} />;
        break;
      // case "/dps":
      //   iconName = <EventNoteIcon className={classes.menuIconProperties} />;
      //   break;
      // case "/pms":
      //   iconName = <EventNoteIcon className={classes.menuIconProperties} />;
      //   break;
      // case "/ais":
      //   iconName = <EventNoteIcon className={classes.menuIconProperties} />;
      case "/efiling":
        iconName = <FolderIcon className={classes.menuIconProperties} />;
        break;

      case "/dwg":
      case "/drawreg":
        iconName = <BurstModeIcon className={classes.menuIconProperties} />;
        break;

      case "/circulation":
        iconName = <MailIcon className={classes.menuIconProperties} />;
        break;

      case "#workflow":
        iconName = <AccountTreeIcon className={classes.menuIconProperties} />;
        break;

      case "/tsf":
      case "/rfi":
      case "/transmittal":
        iconName = <CompareArrowsIcon className={classes.menuIconProperties} />;
        break;

      case "/submission":
        iconName = <DescriptionIcon className={classes.menuIconProperties} />;
        break;

      case "/cmswirs":
        iconName = <ViewListIcon className={classes.menuIconProperties} />;
        break;

      case "/user":
        iconName = <PersonIcon className={classes.menuIconProperties} />;
        break;

      case "#group":
        iconName = <GroupIcon className={classes.menuIconProperties} />;
        break;

      case "/usergroup":
      case "/emailgroup":
        iconName = <GroupIcon className={classes.menuIconProperties} />;
        break;

      default:
        iconName = <LayersIcon className={classes.menuIconProperties} />;
        break;
    }

    return iconName;
  };

  useEffect(() => {
    if (isLoggedIn()) {
      getSite().then((res) => {
        setSiteList(res.data);
        dispatch({
          type: "ADD_USER_SITE",
          data: res.data,
        });
      });

      getModule().then((res) => {
        dispatch({
          type: "ADD_USER_MODULE",
          data: res.data,
        });
      });
    }
  }, []);

  if (!isLoggedIn()) {
    return <Redirect to="/signin" />;
  }

  return (
    // console.log("Token | Variable: token (NavBar.js)"),
    // console.log(token),

    // console.log("Refresh Token | Variable: refreshToken (NavBar.js)"),
    // console.log(refreshToken),

    // console.log("Site List | Variable: siteList (NavBar.js)"),
    // console.log(siteList),

    // console.log("Site List (Redux) | Variable: userSitesRedux (NavBar.js)"),
    // console.log(userSitesRedux),

    // console.log("Modules List (Redux) | Variable: userModulesRedux (NavBar.js)"),
    // console.log(userModulesRedux),

    // console.log("---------------------------------------------------------------------------------"),

    <Router basename={process.env.REACT_APP_URL_ROOT_NAME}>
      <div className={classes.root}>
        <ClickAwayListener onClickAway={handleDrawerClose}>
          <div>
            <AppBar position="fixed" className={classes.appBar}>
              <Toolbar>
                <IconButton
                  aria-label="open drawer"
                  onClick={handleDrawer}
                  edge="start"
                >
                  <WidgetsIcon className={classes.menuIcon} />
                </IconButton>

                <Box className={classes.logo}>
                  <img src={require("../../img/sanfield-logo.png")} alt="" />
                </Box>

                <Hidden smDown>
                  <Box className={classes.menuButton}>
                    <LanguageButton />
                  </Box>
                </Hidden>

                <Hidden smDown>
                  <Box className={classes.menuButton}>
                    <SiteButton siteList={siteList} />
                  </Box>
                </Hidden>

                <Hidden smDown>
                  <UserMenu /*history={history}*/ />
                </Hidden>
              </Toolbar>
            </AppBar>

            <Drawer
              variant="permanent"
              className={clsx(classes.drawer, {
                [classes.drawerOpen]: menuOpen,
                [classes.drawerClose]: !menuOpen,
              })}
              classes={{
                paper: clsx(classes.paper, {
                  [classes.drawerOpen]: menuOpen,
                  [classes.drawerClose]: !menuOpen,
                }),
              }}
              onClick={handleDrawerOpen}
            >
              <div className={classes.sideMenuSpace} />

              <Hidden mdUp>
                <Grid container justify="center" alignItems="center">
                  <Grid item xs={3}>
                    <Box className={classes.paper1}>
                      <LanguageButton />
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box className={classes.paper1}>
                      <SiteButton siteList={siteList} />
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box className={classes.paper1}>
                      <UserMenu history={history} />
                    </Box>
                  </Grid>
                </Grid>
                <Divider className={classes.dividerColor} />
              </Hidden>

              <List>
                {userModulesRedux != null
                  ? userModulesRedux.map((res) => {
                      if (res.status && res.rights.accessible) {
                        if (res.childs.length > 0) {
                          return (
                            <Fragment key={res.module_seq}>
                              <ListItem
                                button
                                onClick={() => {
                                  handleSubMenu(res.name);
                                }}
                              >
                                <ListItemIcon>
                                  {createModuleIcon(res.path)}
                                </ListItemIcon>

                                <ListItemText
                                  primary={
                                    <Typography
                                      className={classes.menuTextProperties}
                                    >
                                      {res.name}
                                    </Typography>
                                  }
                                />

                                {subMenuOpen[res.name] ? (
                                  <ExpandLessIcon
                                    className={classes.menuTextProperties}
                                  />
                                ) : (
                                  <ExpandMoreIcon
                                    className={classes.menuTextProperties}
                                  />
                                )}
                              </ListItem>

                              <Collapse
                                in={subMenuOpen[res.name]}
                                timeout="auto"
                                unmountOnExit
                              >
                                <List component="div" disablePadding>
                                  {res.childs.map((subMod) => {
                                    if (
                                      subMod.status &&
                                      subMod.rights.accessible
                                    ) {
                                      return (
                                        <NavLink
                                          to={subMod.path}
                                          className={
                                            classes.activeLinkProperties
                                          }
                                          key={subMod.module_seq}
                                        >
                                          <ListItem
                                            button
                                            className={classes.nested}
                                          >
                                            <ListItemIcon>
                                              {createModuleIcon(subMod.path)}
                                            </ListItemIcon>
                                            <ListItemText
                                              primary={
                                                <Typography
                                                  className={
                                                    classes.menuTextProperties
                                                  }
                                                >
                                                  {subMod.name}
                                                </Typography>
                                              }
                                            />
                                          </ListItem>
                                        </NavLink>
                                      );
                                    }
                                  })}
                                </List>
                              </Collapse>
                            </Fragment>
                          );
                        } else {
                          return (
                            <NavLink
                              to={res.path}
                              className={classes.activeLinkProperties}
                              key={res.module_seq}
                            >
                              <ListItem button>
                                <ListItemIcon>
                                  {createModuleIcon(res.path)}
                                </ListItemIcon>
                                <ListItemText
                                  primary={
                                    <Typography
                                      className={classes.menuTextProperties}
                                    >
                                      {res.name}
                                    </Typography>
                                  }
                                />
                              </ListItem>
                            </NavLink>
                          );
                        }
                      }
                    })
                  : ""}
              </List>
            </Drawer>
          </div>
        </ClickAwayListener>

        <main className={classes.content}>
          <Switch>
            <Route exact path="/">
              <Dashboard />
            </Route>
            <Route path="/dashboard">
              <Dashboard />
            </Route>
            {/* <Route path="/pas">
              <PAS />
            </Route> */}
            <Route path="/pil">
              <ProjectInformation />
            </Route>
            {/* <Route path="/dps">
              <DPS />
            </Route>
            <Route path="/pms">
              <PMS />
            </Route>
            <Route path="/ais">
              <AIS />
            </Route> */}
            <Route path="/efiling">
              <Efiling fileManagerType={"main"} />{" "}
              {/* main => Main File Manager, select => Select File From File Manager*/}
            </Route>

            <Route path="/dwg">
              <DrawingRegister />
            </Route>

            <Route path="/drawreg">
              <DrawingRegisterO />
            </Route>

            <Route path="/circulation">
              <Circulation />
            </Route>

            <Route path="/tsf"></Route>

            <Route path="/rfi">
              <RFI />
            </Route>

            <Route path="/transmittal">
              <Transmittal />
            </Route>

            <Route path="/submission">
              <DocumentSubmission />
            </Route>

            <Route path="/cmswirs">
              <Wirs />
            </Route>

            <Route path="/user"></Route>

            <Route path="/usergroup">
              <UserGroup />
            </Route>

            <Route path="/emailgroup"></Route>
          </Switch>
        </main>
      </div>
    </Router>
  );
};

export default MenuAppBar;
